import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
// import 'vuetify/src/styles/styles.sass'

const rosconThemeLight = {
  background: '#161616',
  surface: '#161616',
  primary: '#152B59',
  secondary: '#457DB9',
  error: '#B9B9B9',
  info: '#90B5DC',
  success: '#516389',
  warning: '#4682B4',
  gagat: '#161616',
  pauk: '#393939',
  kuzbass: '#010D2D'
}

const rosconThemeDark = {
  background: '#161616',
  surface: '#161616',
  primary: '#152B59',
  secondary: '#457DB9',
  error: '#595959',
  info: '#75A7DC',
  success: '#344873',
  warning: '#4682B4',
  gagat: '#161616',
  pauk: '#393939',
  kuzbass: '#010D2D'
}

const opts = {
  preset: {
    theme: {
      themes: {
        dark: rosconThemeDark,
        light: rosconThemeLight
      }
    }
  }
}

Vue.use(Vuetify)

export default new Vuetify(opts)
